import { 
	SET_ALL_NULL,
	SET_BOARD_ELEMENT_ID,
	SET_BOARD_STRUCTURE_GENERIC,
	SET_BOARD_STRUCTURE_SPECIFIC,
	SET_BOARD_CHARTGAUGE_SELECTED_DATAPOINT,
	SET_BOARD_ELEMENTS,
	SET_BOARD_CHARTS_CONTAINERID_SELECTED,
	SET_BOARD_STRUCTURE_SPECIFIC_BASE,
	SET_BOARD_VARIABLE_DATASERIE_VALUES
} from "./actions/KPI/actions";

const initialState = {
	_elementId: null,
	_boardStructureGeneric: null,
	_boardStructureSpecific: null,
	_boardVariableDataserieValues: null,
	_boardElements: null,
	_selectedGaugeDataPointIndex: 0,
	_listComponentTypeConfig: {
		containerId: null,
		dataserieId: null
	}
};

const boardViewReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_ALL_NULL:
			return {
				_boardStructureGeneric: null,
				_boardStructureSpecific: null,
				_boardVariableDataserieValues: null,
				_boardElements: null,
				_selectedGaugeDataPointIndex: 0
			};
		case SET_BOARD_ELEMENT_ID:
			return {
				...state,
				_elementId: action.payload,
			};
		case SET_BOARD_STRUCTURE_GENERIC:
			return {
				...state,
				_boardStructureGeneric: action.payload.boardStructureGeneric,
				_elementId: action.payload.elementId,
			};
		case SET_BOARD_STRUCTURE_SPECIFIC:
			return {
				...state,
				_boardStructureSpecific: action.payload.boardStructureSpecific,
				_elementId: action.payload.elementId,
			};
		case SET_BOARD_STRUCTURE_SPECIFIC_BASE:
			return {
				...state,
			};	
		case SET_BOARD_CHARTGAUGE_SELECTED_DATAPOINT:
			return {
				...state,
				_selectedGaugeDataPointIndex: action.payload,
			};
		case SET_BOARD_ELEMENTS:
			return {
				...state,
				_boardElements: action.payload
			};	

		case SET_BOARD_CHARTS_CONTAINERID_SELECTED:
			return {
				...state,
				_listComponentTypeConfig: action.payload
			};	
		case SET_BOARD_VARIABLE_DATASERIE_VALUES:
			return {
				...state,
				_boardVariableDataserieValues: action.payload
			};
		default:
			return state;
	}
};

export default boardViewReducer;